import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import StatBlock from '../../Details/_partials/StatBlock';
import TextContent from '../../Details/_partials/TextContent';
import s from './Journal.scss';
var JournalContent = function (_a) {
    var _b, _c;
    var textContent = _a.deviation.textContent, deviation = _a.deviation, _d = _a.withArtist, withArtist = _d === void 0 ? true : _d;
    var isLegacy = (textContent === null || textContent === void 0 ? void 0 : textContent.html.type) === 'writer';
    var isLegacyView = isLegacy && !((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.journalSkinFullwidth);
    var isFullWidthView = isLegacy && ((_c = deviation.extended) === null || _c === void 0 ? void 0 : _c.journalSkinFullwidth);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isMobile = useContext(MobileContext);
    var _e = useSubscriptionTier(deviation), isSubscribedButBlocked = _e.isSubscribedButBlocked, needsSubscription = _e.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    // only show here in full screen, otherwise it's shown in DesktopLayout in the left column
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var shouldShowFullscreenSubPaywall = isBlocked && isFullscreen;
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }),
            !isMobile && ' ')),
        React.createElement(StatBlock, { className: s['stats'], deviation: deviation }),
        !isBlocked && (React.createElement("div", { className: s['wrapper'] }, isExtendedLoaded && (React.createElement(TextContent, { className: classnames(s['text-content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']), textContent: textContent, deviationId: deviation.deviationId, disableStylesForLegacy: isFullWidthView })))),
        shouldShowFullscreenSubPaywall && (React.createElement(SubPaywall, { className: s['paywall'], deviation: deviation, showImage: false }))));
};
JournalContent.displayName = 'JournalContent';
export default JournalContent;
//# sourceMappingURL=Journal.js.map